import React from "react";
import { Booksoffered } from "../components/Books/Booksoffered";
import { ChooseBooks } from "../components/Books/ChooseBooks";
export const BookPage = () => {
  return (
    <>
      <Booksoffered />
      <div id="choose-books">
        <ChooseBooks />
      </div>
    </>
  );
};
